(function (root) {
  'use strict';
  function apiEndpoint(raw) {
    try {
      const url = new URL(String(raw || ''));
      if (url.protocol !== 'https:' || url.username || url.password || url.search || url.hash || /^(?:localhost|127\.|0\.0\.0\.0|\[::1\])/.test(url.hostname)) return null;
      return url.href.replace(/\/+$/, '') + '/v1/passport/verify';
    } catch (_) { return null; }
  }
  function validCode(value) { return typeof value === 'string' && /^[A-Za-z0-9_-]{43}$/.test(value); }
  function publicRecord(payload) {
    if (!payload || payload.status !== 'record_found' || !payload.passport || typeof payload.passport !== 'object') return null;
    const record = {};
    for (const key of ['serial', 'catalogueId', 'title', 'batch', 'issuedAt']) {
      const value = payload.passport[key];
      if (typeof value === 'string' && value.length <= 240) record[key] = value;
    }
    return record.serial && record.catalogueId ? record : null;
  }
  const pure = { apiEndpoint, validCode, publicRecord };
  if (typeof module !== 'undefined' && module.exports) module.exports = pure;
  if (!root || !root.document) return;
  const privateLink = typeof root.__heirTakeLinkToken === 'function' ? root.__heirTakeLinkToken() : null;
  root.HEIRPassport = pure;
  const page = root.document.querySelector('[data-passport-page]');
  if (!page) return;
  const config = root.HEIR || {};
  let copy = {};
  try { copy = JSON.parse(page.querySelector('[data-passport-copy]').textContent); } catch (_) { return; }
  const input = page.querySelector('[data-passport-code]');
  const form = page.querySelector('[data-passport-form]');
  const submit = page.querySelector('[data-passport-check]');
  const demo = page.querySelector('[data-passport-demo]');
  const availability = page.querySelector('[data-passport-availability]');
  const result = page.querySelector('[data-passport-result]');
  const status = page.querySelector('[data-passport-status]');
  const message = page.querySelector('[data-passport-message]');
  const records = page.querySelector('[data-passport-record]');
  const endpoint = apiEndpoint(config.engagementApiUrl);
  const enabled = !!endpoint && config.passportServiceEnabled === true && config.localPreview !== true;
  let busy = false;
  const show = (heading, description, record) => {
    result.hidden = false;
    status.textContent = heading;
    message.textContent = description;
    records.replaceChildren();
    if (record) {
      for (const [key, label] of [['serial','serial'],['title','design'],['batch','batch'],['issuedAt','issued']]) {
        const dt = root.document.createElement('dt');
        const dd = root.document.createElement('dd');
        dt.textContent = copy[label];
        dd.textContent = record[key] || copy.pending;
        records.append(dt, dd);
      }
    }
    result.focus({ preventScroll: true });
  };
  input.disabled = !enabled;
  submit.disabled = !enabled;
  availability.textContent = enabled ? copy.ready : copy.unavailable;
  demo.hidden = false;
  // A fragment is never sent in the HTTP request. Clear it before any later UI
  // interaction; keep it out of logs, storage, telemetry and outbound links.
  try {
    if (privateLink && privateLink.kind === 'code' && validCode(privateLink.token)) input.value = privateLink.token;
    const params = new URLSearchParams(root.location.hash.slice(1));
    if (params.has('code')) {
      const code = params.get('code');
      root.history.replaceState(root.history.state, '', root.location.pathname + root.location.search);
      if (validCode(code)) input.value = code;
    }
  } catch (_) { /* malformed fragments must not break the page */ }
  demo.addEventListener('click', () => {
    if (busy) return;
    show(copy.demoTitle, copy.demoBody, { serial: 'DEMO — NOT ISSUED', title: 'HEIR / demonstration', batch: 'DEMO — NOT PRODUCTION', issuedAt: copy.pending });
  });
  form.addEventListener('submit', async (event) => {
    event.preventDefault();
    if (!enabled || busy) return;
    const code = input.value.trim();
    if (!validCode(code)) { show(copy.invalid, copy.recordNotice); input.focus(); return; }
    busy = true;
    submit.disabled = true;
    demo.disabled = true;
    status.textContent = copy.checking;
    records.replaceChildren();
    message.textContent = '';
    result.hidden = false;
    const controller = new AbortController();
    const timer = root.setTimeout(() => controller.abort(), 12000);
    try {
      const response = await root.fetch(endpoint, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, credentials: 'omit', cache: 'no-store', referrerPolicy: 'no-referrer', body: JSON.stringify({ code }), signal: controller.signal });
      if (!response.ok) throw new Error('Verification unavailable');
      const data = await response.json();
      if (data.status === 'not_found') show(copy.notFound, copy.recordNotice);
      else {
        const record = publicRecord(data);
        if (!record) throw new Error('Invalid public response');
        show(copy.found, copy.recordNotice, record);
      }
    } catch (_) { show(copy.error, copy.recordNotice); }
    finally { root.clearTimeout(timer); busy = false; submit.disabled = false; demo.disabled = false; input.value = ''; }
  });
})(typeof window === 'undefined' ? null : window);
